// src/theme.js
export const theme = {
  colors: {
    // Primary deep red/pink from the main background of the business card
    primary: '#CC3333',     // This is an approximation of the deep red/pink

    // The lighter, softer pink from the semi-circle behind the photo
    secondary: '#FFCCCC',   // An approximation of the lighter pink

    // White text color used on the card
    text: '#CC3333',        // Text color is white on the dark background

    // The color of "Elva Osorio" text, which is a darker shade of the primary color
    accent: '#B22222',      // Darker red/pink for emphasis, similar to Elva Osorio text

    // Background color, assuming this refers to the overall canvas if there were one
    background: '#F5F5F5',  // A very light grey/off-white similar to the outer border in the image

    // If you need a dark background for other elements
    darkBg: '#CC3333',      // Using the primary card color as a dark background reference

    // Keeping other utility colors if they are still needed for your system,
    // though they don't directly appear on the business card.
    lightText: '#666666',   // Keeping light text color (not seen on card)
    success: '#00C853',     // Keeping success color (not seen on card)
    primaryLight: '#FFCCCC' // Using the soft pink from the card here
},
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1440px'
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  }
};
